import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import { Navigation } from '@/components/Navigation';
import { Footer } from '@/components/Footer';
import CanonicalTag from '@/components/CanonicalTag';
import aduWithoutMainHouseImage from '@/assets/adu-without-main-house.jpg';

const CanYouBuildADUWithoutMainHouseCalifornia = () => {
  const [showCalendly, setShowCalendly] = useState(false);
  const openCalendlyModal = () => setShowCalendly(true);
  const closeCalendlyModal = () => setShowCalendly(false);

  return (
    <>
      <CanonicalTag url="https://www.udaadu.com/build-adu-without-main-house-california" />
      
      {/* Calendly Modal */}
      {showCalendly && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
          <div className="relative bg-white rounded-lg w-full max-w-4xl h-full max-h-[90vh]">
            <button 
              onClick={closeCalendlyModal} 
              className="absolute top-4 right-4 z-10 p-2 bg-white rounded-full shadow-md hover:bg-gray-100 transition-colors"
            >
              ✕
            </button>
            <iframe 
              src="https://calendly.com/udaadu?embed=true&hide_gdpr_banner=1" 
              width="100%" 
              height="100%" 
              frameBorder="0" 
              title="Schedule a meeting"
            />
          </div>
        </div>
      )}
      
      <div className="min-h-screen bg-background">
        <Navigation />
        
        <main className="container mx-auto px-4 py-8">
          {/* Hero Section */}
          <div className="mb-12">
            <img 
              src={aduWithoutMainHouseImage} 
              alt="ADU planning without main house" 
              className="w-full h-64 md:h-96 object-cover rounded-lg mb-8"
            />
            
            <h1 className="text-4xl md:text-5xl font-bold mb-6" style={{ color: '#E4683B' }}>
              Can You Build an ADU Without a Main House in California?
            </h1>
            
            <p className="text-lg md:text-xl text-white leading-relaxed mb-8">
              Explore California regulations on constructing an ADU without an existing main house, including city-specific exceptions and zoning insights.
            </p>
          </div>

          {/* Content Sections */}
          <div className="space-y-12">
            <section>
              <h2 className="text-3xl font-bold mb-6" style={{ color: '#E4683B' }}>
                ADU First: Understanding California's Primary Structure Rules
              </h2>
              <p className="text-white leading-relaxed mb-6">
                California's ADU legislation defines accessory dwelling units as secondary to a primary residence. The state generally requires an existing or simultaneously constructed primary dwelling before ADU approval, though some jurisdictions may offer conditional pathways for ADU-first construction.
              </p>
            </section>

            <section>
              <h2 className="text-3xl font-bold mb-6" style={{ color: '#E4683B' }}>
                Exceptions and Special Zoning Considerations
              </h2>
              <p className="text-white leading-relaxed mb-6">
                Certain California cities have created special zoning exceptions allowing ADU construction without existing primary structures. These exceptions typically require conditional use permits, compliance with specific density requirements, and demonstration that the ADU serves community housing goals.
              </p>
            </section>

            <section>
              <h2 className="text-3xl font-bold mb-6" style={{ color: '#E4683B' }}>
                Steps to Legally Build an ADU First in California
              </h2>
              <p className="text-white leading-relaxed mb-6">
                To legally build an ADU first, consult your city's planning department about conditional use permits, submit detailed site plans showing future primary structure placement, obtain special zoning approval, and ensure compliance with all building codes and utility requirements for standalone ADU construction.
              </p>
            </section>

            <section>
              <h2 className="text-3xl font-bold mb-6" style={{ color: '#E4683B' }}>
                Frequently Asked Questions
              </h2>
              <div className="text-white leading-relaxed space-y-6">
                <div>
                  <p className="font-semibold mb-2">Q: Is a primary residence required before building an ADU?</p>
                  <p>A: Usually yes, though exceptions vary by city zoning rules.</p>
                </div>
                
                <div>
                  <p className="font-semibold mb-2">Q: How can I build an ADU first legally in California?</p>
                  <p>A: Obtain special permits or conditional approval from your city's planning department.</p>
                </div>
              </div>
            </section>
          </div>

          {/* Call-to-Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center mt-12">
            <Button 
              onClick={openCalendlyModal}
              className="bg-primary text-primary-foreground hover:bg-primary/90 px-8 py-3 text-lg"
            >
              Book & Schedule
            </Button>
            <Button 
              asChild
              variant="outline"
              className="border-primary text-primary hover:bg-primary hover:text-primary-foreground px-8 py-3 text-lg"
            >
              <Link to="/landing">Learn More</Link>
            </Button>
          </div>
        </main>

        <Footer />
      </div>
    </>
  );
};

export default CanYouBuildADUWithoutMainHouseCalifornia;